/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, array, bool, func } from 'prop-types';

import TagPicker from 'components/TagPicker/TagPicker';

import styles from './tags-input.scss';

/**
 * This is the TagsInput component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class TagsInput extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    name: string.isRequired,
    placeholder: string,
    value: string,
    options: array.isRequired,
    required: bool,
    disabled: bool,
    readOnly: bool,
    error: bool,
    onFocus: func,
    onBlur: func,
    onChange: func,
  };

  static defaultProps = {
    placeholder: '',
    value: '',
    required: false,
    error: false,
    disabled: false,
    readOnly: false,
    large: false,
    compact: false,
    onFocus: () => {},
    onBlur: () => {},
    onChange: () => {},
  };

  /**
   * Create TagsInput.
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    const { value, options } = this.props;
    const tags = value ? value.split(', ') : [];

    const selectedTags = options.filter(
      option => tags.indexOf(option.value) !== -1
    );

    this.state = {
      selectedTags,
    };
  }

  onChange = tags => {
    this.setState(
      {
        selectedTags: tags,
      },
      () => {
        const event = new Event('input', { bubbles: true });
        this.input.dispatchEvent(event);
      }
    );
  };

  /**
   * Render TagsInput.
   *
   * @return {Object}
   */
  render() {
    const { selectedTags } = this.state;

    const {
      name,
      placeholder,
      options,
      required,
      disabled,
      readOnly,
      error,
      onFocus,
      onBlur,
      onChange,
    } = this.props;

    const value = selectedTags.map(({ value }) => value);

    return (
      <div className={styles.wrapper}>
        {
          // This input is used to save the value choosen by the TagPicker.
          // Everytime the TagPicker is updated the input value is changed.
          // The validation of the input will therefore be the same as the validation
          // for the "regular" inputs.
        }
        <input
          type="hidden"
          id={name}
          value={value.join(', ')}
          ref={ref => {
            this.input = ref;
          }}
          onInput={onChange}
          {...{
            name,
            required,
            disabled,
            readOnly,
          }}
        />

        <TagPicker
          value={selectedTags}
          placeholder={placeholder}
          options={options}
          onChange={this.onChange}
          creatable={false}
          openMenuOnClick
          isDisabled={disabled || readOnly}
          onFocus={onFocus}
          onBlur={onBlur}
          error={error}
        />
      </div>
    );
  }
}
